import { useEffect } from 'react';
import toast from 'react-hot-toast';

export default function Login() {
  useEffect(() => {
    // Check for error parameters in URL
    const urlParams = new URLSearchParams(window.location.search);
    const error = urlParams.get('error');
    const description = urlParams.get('description');
    
    if (error) {
      const errorMessages: Record<string, string> = {
        'unauthorized': 'You are not authorized to access the MSP admin portal.',
        'inactive': 'Your admin account is inactive.',
        'login_failed': 'Login failed. Please try again.',
      };
      
      const message = errorMessages[error] || description || 'Authentication error occurred.';
      toast.error(message);
      
      // Clear the error from URL
      window.history.replaceState({}, document.title, window.location.pathname);
    }
  }, []);

  const handleLogin = () => {
    const apiUrl = import.meta.env.VITE_API_URL || 'https://admin.sign.virtue.dk';
    // Redirect to Microsoft OAuth login - always go to dashboard after login
    window.location.href = `${apiUrl}/api/auth/login?redirect=/dashboard`;
  };

  return (
    <div style={{
      minHeight: '100vh',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
      padding: '20px',
    }}>
      <div style={{
        background: 'white',
        padding: '48px',
        borderRadius: '16px',
        boxShadow: '0 20px 25px -5px rgba(0, 0, 0, 0.1), 0 10px 10px -5px rgba(0, 0, 0, 0.04)',
        width: '100%',
        maxWidth: '420px',
      }}>
        <div style={{ textAlign: 'center', marginBottom: '32px' }}>
          <div style={{ fontSize: '48px', marginBottom: '16px' }}>🛡️</div>
          <h1 style={{ fontSize: '28px', fontWeight: 'bold', color: '#1f2937', marginBottom: '8px' }}>
            MSP Admin Portal
          </h1>
          <p style={{ color: '#6b7280', fontSize: '14px' }}>
            VirtueSign Support Dashboard
          </p>
        </div>

        <div style={{ textAlign: 'center' }}>
          <button
            onClick={handleLogin}
            style={{
              width: '100%',
              padding: '14px 20px',
              background: '#0078d4',
              color: 'white',
              border: 'none',
              borderRadius: '8px',
              fontSize: '15px',
              fontWeight: '600',
              cursor: 'pointer',
              transition: 'all 0.2s',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              gap: '12px',
            }}
            onMouseEnter={(e) => {
              e.currentTarget.style.background = '#106ebe';
              e.currentTarget.style.transform = 'translateY(-1px)';
            }}
            onMouseLeave={(e) => {
              e.currentTarget.style.background = '#0078d4';
              e.currentTarget.style.transform = 'translateY(0)';
            }}
          >
            <svg width="20" height="20" viewBox="0 0 23 23" fill="currentColor">
              <path d="M11.03 22.46H1.57V13h9.46v9.46zM21.43 22.46H11.97V13h9.46v9.46zM11.03 12.06H1.57V2.6h9.46v9.46zM21.43 12.06H11.97V2.6h9.46v9.46z"/>
            </svg>
            Sign in with Microsoft 365
          </button>

          <div style={{
            marginTop: '24px',
            padding: '16px',
            background: '#f3f4f6',
            borderRadius: '8px',
            fontSize: '13px',
            color: '#6b7280',
            lineHeight: '1.5',
          }}>
            <div style={{ fontWeight: '500', marginBottom: '4px' }}>MSP Staff Only</div>
            You must be added as an admin user and have a Microsoft 365 account in the Virtue organization.
          </div>
        </div>

      </div>
    </div>
  );
}
